import { SPage } from 'servisofts-component2';

import root from './root';
import backgroundlocation from './backgroundlocation';
import notificacion from './notificacion';
import bateria from './bateria';

export default SPage.combinePages("permiso", {
  "": root,
  "notificacion": notificacion,
  "backgroundlocation": backgroundlocation,
  "bateria": bateria,

});